import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { AlertTriangle, ArrowRight, RefreshCw } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const REASON_COPY = {
  missing_params: 'The callback was missing required information from Alpaca.',
  invalid_state: 'The OAuth security check failed. Please try connecting again.',
  state_expired: 'Your connection attempt expired. Please start again.',
  user_not_found: 'Your session was lost during the connection. Please log in and retry.',
  server_not_configured: 'Talas is not finished configuring Alpaca. Please contact support.',
  token_exchange_failed: 'We could not reach Alpaca to complete the connection.',
  token_rejected: 'Alpaca rejected the connection request. Please try again.',
  token_response_invalid: 'Alpaca returned an unexpected response. Please try again.',
  no_access_token: 'No access token was returned by Alpaca.',
  token_storage_failed: 'We could not securely store your Alpaca token.',
  access_denied: 'You declined the Alpaca authorization request.',
};

export default function AlpacaError() {
  const [search] = useSearchParams();
  const reason = search.get('reason') || 'unknown';
  const message = REASON_COPY[reason] || 'We could not connect your Alpaca paper account.';

  return (
    <div className="min-h-screen bg-[#0a0a0b] flex flex-col">
      <Navbar />
      <main className="flex-1 flex items-center justify-center px-5 py-16">
        <div className="w-full max-w-lg text-center">
          <div className="w-14 h-14 mx-auto rounded-full border border-red-500/40 bg-red-500/[0.06] flex items-center justify-center">
            <AlertTriangle size={26} className="text-red-400" strokeWidth={1.6} />
          </div>
          <p className="mt-6 text-[10px] tracking-[0.25em] font-mono text-red-400">CONNECTION FAILED</p>
          <h1 className="font-display mt-3 text-3xl sm:text-4xl font-bold text-white leading-tight">
            Could not connect<br /><span className="gold-text">your Alpaca account.</span>
          </h1>
          <p className="mt-5 text-sm text-zinc-300 leading-relaxed">{message}</p>
          <p className="mt-3 text-[11px] text-zinc-500 font-mono">Reason code: {reason}</p>

          <div className="mt-9 flex flex-col sm:flex-row sm:justify-center gap-3">
            <a
              href="/api/alpaca/oauth/start"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 bg-[#d8b34a] text-black font-semibold text-sm rounded-sm hover:bg-[#e6c365] transition-colors"
            >
              <RefreshCw size={14} />
              Try Again
            </a>
            <Link
              to="/dashboard"
              className="inline-flex items-center justify-center gap-2 px-6 py-3.5 border border-white/15 text-zinc-200 hover:border-[#d8b34a]/60 hover:text-white rounded-sm text-sm transition-colors"
            >
              Back to Dashboard <ArrowRight size={14} />
            </Link>
          </div>
          <p className="mt-8 text-xs text-zinc-500">
            Need help? <Link to="/contact" className="gold-text hover:underline">Contact support</Link>
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
